import {
  IonIcon, IonImg, IonPage, IonText,
} from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import YoutubeEmbed from '@/components/learning/YoutubeEmbed/YoutubeEmbed';
import { ROUTES_PATH } from '@/constants';
import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';
import {
  VideoItems,
  VideoResponse,
} from '@/interfaces/LearningInterface/LearningInterface';
import { DateHelperShort } from '@/utils/dateHelper';

import styles from './WebinarDetail.module.scss';

export default function WebinarDetail() {
  const history = useHistory();
  const location = useLocation();

  const [webinar, setwebinar] = useState<VideoItems>(
    location.state as VideoItems,
  );
  const [webinarList, setwebinarList] = useState<VideoItems[]>([]);
  const isTablet = useMediaQuery(Breakpoint.Tablet);
  const isDesktop = useMediaQuery(Breakpoint.Tablet);
  const webinarContentRef = useRef<HTMLDivElement>(null);

  const [isMobile, setIsMobile] = useState(!isTablet && !isDesktop);

  useEffect(() => {
    setIsMobile(!isTablet && !isDesktop);
  }, [isTablet, isDesktop]);

  useEffect(() => {
    if (location.state) {
      setwebinar(location.state as VideoItems);
      if (webinarContentRef.current) {
        webinarContentRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.state]);

  useEffect(() => {
    getWebinarsFromApi();
  }, []);

  const getWebinarsFromApi = async () => {
    try {
      const response = await fetch(
        'https://www.googleapis.com/youtube/v3/playlistItems?key=AIzaSyAb8W--TEpkE3oqvwi7XOXGznIh7vHK3_g&playlistId=PLP9ms8Ry_5Oa7nnk6BTyC7N7tmEM2-ecy&part=id,snippet,contentDetails,status',
      );
      const responseJson: VideoResponse = await response.json();
      setwebinarList(responseJson.items);
    } catch (error) {
      console.error(error);
    }
  };

  const handleViewAll = (route: ROUTES_PATH) => {
    if (isMobile) {
      return history.push(ROUTES_PATH.ALL_RESOURCES_MOBILE, { route });
    }
    history.push(route);
  };

  return (
    <IonPage>
      <div className={styles.webinarPage}>
        <div className={styles.titleWrapper}>
          <Link className={styles.backBtn} to={ROUTES_PATH.LEARNING}>
            <IonIcon slot="start" icon={chevronBackOutline} />
            <span className={styles.fullText}>Volver a webinars</span>
            <span className={styles.shortText}>Volver</span>
          </Link>
        </div>
        <div className={styles.webinarContent} ref={webinarContentRef}>
          <div className={styles.mainContent}>
            <YoutubeEmbed embedId={webinar?.snippet?.resourceId?.videoId} />
            <div className={styles.textContent}>
              <IonText className={styles.titleText}>
                {webinar?.snippet?.title}
              </IonText>
              <IonText className={styles.descriptionText}>
                {webinar?.snippet?.description}
              </IonText>
            </div>
          </div>
          <div className={styles.webinarList}>
            <div className={styles.listHeader}>
              <IonText className={styles.otherWebiTitle}>Otros webinars</IonText>
              <div onClick={() => handleViewAll(ROUTES_PATH.WEBINAR_ALL)} className={styles.seeAll}>
                Ver todos
              </div>
            </div>
            <div className={styles.otherWebinarsContent}>
              {webinarList.map((webinarItem: VideoItems, index) => {
                if (webinar.id !== webinarItem.id) {
                  return (
                    <Link
                      to={{
                        pathname:
                          `${ROUTES_PATH.WEBINAR_DETAIL}/${webinarItem.id}`,
                        state: webinarItem,
                      }}
                      className={styles.otherWebinarsWrapper}
                      key={index}
                    >
                      <IonImg
                        src={webinarItem?.snippet?.thumbnails?.medium?.url}
                        className={styles.webiImg}
                      />
                      <div className={styles.webiText}>
                        <div className={styles.dateContent}>
                          {DateHelperShort(webinar?.snippet?.publishedAt)}
                        </div>
                        <IonText className={styles.titleText}>
                          {webinarItem?.snippet?.title}
                        </IonText>
                      </div>
                    </Link>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </IonPage>
  );
}
